// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-execution/shared/ExecutionEmptyState.jsx

import React from "react";
import { EmptyState } from "../../../design-system/components";

function displayValue(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }
  return fallback;
}

export default function ExecutionEmptyState({
  title = "No data available",
  message,
}) {
  return (
    <EmptyState
      title={displayValue(title, "No data available")}
      description={message ? displayValue(message, "") : null}
      size="compact"
      className="execution-empty-state"
    />
  );
}
